import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CallHistoryFilters = ({ onFilterChange, onExport, onReset }) => {
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    callType: '',
    disposition: '',
    agent: '',
    searchTerm: ''
  });

  const callTypeOptions = [
    { value: '', label: 'Tüm Aramalar' },
    { value: 'Gelen', label: 'Gelen Aramalar' },
    { value: 'Giden', label: 'Giden Aramalar' }
  ];

  const dispositionOptions = [
    { value: '', label: 'Tüm Sonuçlar' },
    { value: 'Başarılı', label: 'Başarılı' },
    { value: 'Meşgul', label: 'Meşgul' },
    { value: 'Cevapsız', label: 'Cevapsız' },
    { value: 'Geri Arama', label: 'Geri Arama' },
    { value: 'Yanlış Numara', label: 'Yanlış Numara' }
  ];

  const agentOptions = [
    { value: '', label: 'Tüm Temsilciler' },
    { value: 'Ahmet Yılmaz', label: 'Ahmet Yılmaz' },
    { value: 'Ayşe Demir', label: 'Ayşe Demir' },
    { value: 'Mehmet Kaya', label: 'Mehmet Kaya' },
    { value: 'Fatma Şahin', label: 'Fatma Şahin' },
    { value: 'Ali Özkan', label: 'Ali Özkan' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const resetFilters = {
      dateFrom: '',
      dateTo: '',
      callType: '',
      disposition: '',
      agent: '',
      searchTerm: ''
    };
    setFilters(resetFilters);
    onReset();
  };

  const handleQuickDateFilter = (days) => {
    const today = new Date();
    const fromDate = new Date(today);
    fromDate?.setDate(today?.getDate() - days);
    
    const newFilters = {
      ...filters,
      dateFrom: fromDate?.toISOString()?.split('T')?.[0],
      dateTo: today?.toISOString()?.split('T')?.[0]
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  return (
    <div className="bg-white rounded-lg shadow-subtle border border-slate-200 p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-900">Arama Geçmişi Filtreleri</h3>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            Dışa Aktar
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleReset}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Sıfırla
          </Button>
        </div>
      </div>
      {/* Search Bar */}
      <div className="mb-4">
        <Input
          type="search"
          placeholder="Müşteri adı, telefon numarası veya notlarda ara..."
          value={filters?.searchTerm}
          onChange={(e) => handleFilterChange('searchTerm', e?.target?.value)}
          className="w-full"
        />
      </div>
      {/* Quick Date Filters */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-slate-700 mb-2">
          Hızlı Tarih Filtreleri
        </label>
        <div className="flex flex-wrap gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleQuickDateFilter(1)}
          >
            Bugün
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleQuickDateFilter(7)}
          >
            Son 7 Gün
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleQuickDateFilter(30)}
          >
            Son 30 Gün
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleQuickDateFilter(90)}
          >
            Son 3 Ay
          </Button>
        </div>
      </div>
      {/* Filter Controls */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        <div className="xl:col-span-2">
          <div className="grid grid-cols-2 gap-2">
            <Input
              type="date"
              label="Başlangıç Tarihi"
              value={filters?.dateFrom}
              onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
            />
            <Input
              type="date"
              label="Bitiş Tarihi"
              value={filters?.dateTo}
              onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
            />
          </div>
        </div>

        <Select
          label="Arama Türü"
          options={callTypeOptions}
          value={filters?.callType}
          onChange={(value) => handleFilterChange('callType', value)}
        />

        <Select
          label="Arama Sonucu"
          options={dispositionOptions}
          value={filters?.disposition}
          onChange={(value) => handleFilterChange('disposition', value)}
        />

        <Select
          label="Temsilci"
          options={agentOptions}
          value={filters?.agent}
          onChange={(value) => handleFilterChange('agent', value)}
          searchable
        />

        <div className="flex items-end">
          <Button
            variant="default"
            className="w-full"
            iconName="Search"
            iconPosition="left"
          >
            Filtrele
          </Button>
        </div>
      </div>
      {/* Active Filters Display */}
      {(filters?.dateFrom || filters?.dateTo || filters?.callType || filters?.disposition || filters?.agent || filters?.searchTerm) && (
        <div className="mt-4 pt-4 border-t border-slate-200">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-slate-700">Aktif Filtreler:</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleReset}
              iconName="X"
            >
              Tümünü Temizle
            </Button>
          </div>
          <div className="flex flex-wrap gap-2 mt-2">
            {filters?.searchTerm && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                <Icon name="Search" size={12} className="mr-1" />
                Arama: {filters?.searchTerm}
                <button
                  onClick={() => handleFilterChange('searchTerm', '')}
                  className="ml-1 hover:text-blue-600"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            {filters?.dateFrom && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                <Icon name="Calendar" size={12} className="mr-1" />
                Başlangıç: {filters?.dateFrom}
                <button
                  onClick={() => handleFilterChange('dateFrom', '')}
                  className="ml-1 hover:text-green-600"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            {filters?.dateTo && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                <Icon name="Calendar" size={12} className="mr-1" />
                Bitiş: {filters?.dateTo}
                <button
                  onClick={() => handleFilterChange('dateTo', '')}
                  className="ml-1 hover:text-green-600"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            {filters?.callType && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                <Icon name="Phone" size={12} className="mr-1" />
                Tür: {filters?.callType}
                <button
                  onClick={() => handleFilterChange('callType', '')}
                  className="ml-1 hover:text-purple-600"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            {filters?.disposition && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                <Icon name="CheckCircle" size={12} className="mr-1" />
                Sonuç: {filters?.disposition}
                <button
                  onClick={() => handleFilterChange('disposition', '')}
                  className="ml-1 hover:text-orange-600"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            {filters?.agent && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                <Icon name="User" size={12} className="mr-1" />
                Temsilci: {filters?.agent}
                <button
                  onClick={() => handleFilterChange('agent', '')}
                  className="ml-1 hover:text-indigo-600"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CallHistoryFilters;